<template>
<div>
<v-dialog v-model="dialog.open" max-width="600px">
      <v-card>
        <v-card-title>
          <span >{{dialog.title}}</span>
        </v-card-title>
        <v-card-text>
          <p v-html="dialog.message">{{dialog.message}}</p>
          <p v-if="dialog.cardMessage">{{dialog.cardMessage}}</p>
           <a @click="() =>{dialog.open = false; !dialog.action && $emit('returnLogin');}" class="btn block">{{ t('FECHAR') }}</a>
        </v-card-text>
      </v-card>
    </v-dialog>
 <footer>
     <div class="container">
        <div class="fl1">
            <div class="fl1c1">
                <img src="../assets/img/tudomudanumgiro.png" alt="">
            </div>
            <div class="fl1c2">
                <div class="fl1c2l1">
                    <a href="https://whatsapp.com/channel/0029ValO4r6I1rcq2fl6vp1N"><img src="../assets/img/logowp2.png" alt="WhatsApp"></a>
                    <a href="https://www.instagram.com/metro_rio/"><img src="../assets/img/logoinsta.png" alt="Instagram"></a>
                    <a href="https://www.facebook.com/metrodorio"><img src="../assets/img/facebook-circle.png" alt="Facebook"></a>
                    <a href="https://twitter.com/metro_rio"><img src="../assets/img/twitter-circle.png" alt="Twitter"></a>
                    <a href="https://www.tiktok.com/@metrodorio"><img src="../assets/img/tiktok-circle.png" alt="TikTok"></a>
                    <a href="https://www.linkedin.com/company/metr-rio/mycompany"><img src="../assets/img/linkedin-circle.png" alt="LinkedIn"></a>
                </div>
                <div class="fl1c2l2">
                    <a @click="$router.push({name:'termos-de-uso'})" appEvent="true"  appEventCategory="pop-up" appEventLabel="Termos e condições de uso">{{ t('TERMOS_CONDICOES') }}</a>
                    <a @click="$router.push({name:'politica-privacidade'})" appEvent="true"  appEventCategory="pop-up" appEventLabel="Politica de privacidade">{{ t('DECLARACAO_PRIVACIDADE') }}</a>
                </div>
            </div>
        </div>
        <div class="fl1 lojas">
            <a href="http://onelink.to/mu5fuq"><img src="../assets/img/btn-app-store.png" alt="Apple Store"></a>
            <a href="http://onelink.to/mu5fuq"><img src="../assets/img/btn-play-store.png" alt="Play Store"></a>
        </div>
        <div class="fl2">
            <div class="fl2c1">
                <p>{{ t('COPYRIGHT', [year]) }}</p>
            </div>
            <div class="fl2c2">
                <a href="http://www.metrorio.com.br/"><img src="../assets/img/Logo_MetroRio2.png" class="metrorio"  alt=""></a>
                <!--<a href="http://www.invepar.com.br/"><img src="../assets/img/logo-invepar.png"  class="invepar" alt=""></a>-->
            </div>
        </div>
     </div>
 </footer>
</div>
</template>
<script>
import {VDialog,VCard,VCardTitle,VCardText} from 'vuetify/lib'
import { translate } from '../services/translate.service';

export default {
  name: 'Footer',
  data(){
    return {
        dialog:{
        open:false,
        message:null,
        title:null,
        cardMessage:null,
        action:null
      }
    }
  },
  components:{
      VDialog,
      VCard,
      VCardTitle,
      VCardText
  },
  props:{
    privacy:{
      type:Object
    },
    terms:{
      type:Object
    }
  },
  computed: {
      year: () => (new Date).getFullYear()
  },
  methods:{
    t: translate,
     openTerms(){
        this.dialog.title = "Termos e Condições"
        this.dialog.action = "terms"
        if(!this.terms){
            resolvePromise(getActiveTermsAndConditions(),({data})=> {
                this.terms = data
                this.dialog.message = this.terms.text
                this.dialog.open = true
            },console.log,this)
        } else {
            this.dialog.message = this.terms.text
            this.dialog.open = true
        }
    },
    openPrivacy(){
        this.dialog.title = "Declaração de Privacidade"
        this.dialog.action = 'privacy'
        if(!this.privacy){
            resolvePromise(getActivePrivacyPolicy(),({data})=> { 
                this.privacy = data;
                this.dialog.message = this.privacy.text
                this.dialog.open = true
            },console.log,this)
        } else {
            this.dialog.message = this.privacy.text
            this.dialog.open = true
        }
    },
  }
}
</script>

<style scoped lang="scss">
    .footer-area { position: absolute; left: 0; right: 0; bottom: 0;}
    footer {
        background: #671176;
        color: white;  
        padding: 1px;
        font-size: 14px;
        .fl1.lojas {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start !important;
            column-gap: 10px;
            padding-top: 20px;
            @media(max-width: 992px) {
            }
            a {
                z-index: 99999999;
                width: 25%;
                max-width: 120px;
                img {
                    width: 100%;
                }
            }
        }

        .fl1 {
            display: flex;
            justify-content: space-between;
            text-align: right;;
            .fl1c1 {
                img {
                    width: 120px;
                }
            }
            .fl1c2 {
                flex-direction: column;
                display: flex;
                justify-content: space-between;
               
                .fl1c2l1 {
                    a {
                        padding-top: 0;
                        padding-bottom: 0;
                    }
                    img {
                        width: 50px;
                    }
                }
                .fl1c2l2 {
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 10px;
                    padding-top: 5px;
                    @media(max-width: 992px) {
                        margin-bottom: -30px;
                    }
                    img {
                        max-width: 150px;
                        
                    }
                }

                a {
                    display: block;
                    color: white;
                    padding: 5px 10px;
                    display: inline-block;
                    cursor: pointer;
                }
            }
        }
        .fl2 {
            display: flex;
            padding-top: 10px;
            justify-content: space-between;
            align-items: center;
            .fl2c1 {

            }
            .fl2c2 {
                img {
                    max-width: 90px;
                    &.invepar { max-width: 65px; }
                    &.metrorio { max-width: 120px; }
                }
                a {
                    padding: 0 5px;
                    display: inline-block;
                }
            }
        }      
    }
    @media(max-width: 992px) {
        footer .container { margin: 0;}
        footer .fl1 .fl1c1 img { width: 60px }
        footer .fl1 .fl1c2 a {
            padding: 5px;   
        }
        footer .fl1 .fl1c2 .fl1c2l2 {
            a { font-size: 12px; line-height: 10px; padding: 3px 0;}
        }
        footer .fl1 .fl1c2 {
            width: calc((45vw / 3) * 2);
            width: 100%;
        }
        footer .fl1 .fl1c2 .fl1c2l1 a { width: 33%; width: auto;}
        footer .fl1 .fl1c2 .fl1c2l1 img { max-width: 50px; width: 100%; width: 30px; }
        footer .fl2 {
            padding-top: 3px;
            //flex-direction: column-reverse;
            //display: none;
            .fl2c2 { 
                a { width: 50%;
                    display: flex;
                    align-items: center;
                    &:first-child { width: 60% }
                    &:last-child { width: 100% }
                }
            }
            .fl2c2 img {
                &.invepar { max-width: 100% }
                &.metrorio { max-width: 100%; }
            }
            > div {
                padding: 5px 0;
                display: flex;
                width: calc((45vw / 3) * 2);
                &.fl2c1 { width: auto; flex: 1}
                p {
                    font-size: 12px;
                }
            }
        }
    }
</style>
